module.exports = __webpack_public_path__ + "img/Icon ionic-md-list-box.a8d7109c.svg";